import {Component, Input} from '@angular/core';
import {PayrollMonthlyRate, validMonthlyRate} from 'app/models/payroll-currency.model';

const INTEGER_RATE_DIGITS = '1.0-0';
const MONEY_DIGITS = '1.2-2';

@Component({
  selector: 'app-salary-sources',
  templateUrl: './salary-sources.component.html',
  styleUrls: ['./salary-sources.component.css']
})
export class SalarySourcesComponent {
  @Input() rate: PayrollMonthlyRate | null;
  @Input() showBreakdown = false;
  @Input() gradeLabelKey: string;
  @Input() deal = false;
  get available(): boolean { return validMonthlyRate(this.rate); }
  get amount(): number { return this.available ? (this.showBreakdown ? this.rate.baseAmount : this.rate.effectiveAmount) : null; }
  get digitsInfo(): string { return this.deal && !this.showBreakdown ? INTEGER_RATE_DIGITS : MONEY_DIGITS; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/salary-sources/salary-sources.component.ts